import classNames from 'classnames';
import { observer } from 'mobx-react';
import moment from 'moment';
import { TimePickerMode } from '~/constants/dateTime';
import Text from '~/view/components/Text/Text';
import WeekModalOpen from '~/view/containers/Modals/WeekModal/components/WeekModalOpen/WeekModalOpen';
import { promobannerStore } from '../../store/promobannerStore';
import { usePromoBannerValidityHook } from './hooks/usePromobannerValidityHook';
import './style.scss';

const PromobannerValidity = observer(() => {
  const [placeholder, startDate, endDate, daysOfWeek, timeByDays, onSave] = usePromoBannerValidityHook();

  return (
    <div className="d-flex flex-column mt-6 promobanner-validity">
      <Text type="block-header" text="validity" required />
      <div className="promobanner-validity__container d-flex flex-row mt-2">
        <WeekModalOpen
          startDate={startDate}
          endDate={endDate}
          startTime={undefined}
          endTime={undefined}
          onSave={onSave}
          placeholder={placeholder}
          validateTime={validateScheduledTime}
          messageOnError="promobanners_validity_time_settings_comparison_error"
          title="promobanner_validity_modal_hdr"
          className={classNames({ 'input-error': !promobannerStore.isValid.start_date })}
          minimumOneDayInWeek
          timePickerMode={TimePickerMode.DAYTIME_RANGE}
          daysOfWeek={daysOfWeek}
          timeByDays={timeByDays}
          hideAdditionalSettings={false}
          allDay={promobannerStore.promobanner.active_24_hours}
        />
      </div>
    </div>
  );
});

const validateScheduledTime = (time: Date | undefined, type?: 'start' | 'end', oppositeTime?: Date): boolean => {
  const timeMoment = moment(time, 'HH:mm:ss');
  const oppositeTimeMoment = moment(moment(oppositeTime).format('HH:mm:ss'), 'HH:mm:ss');

  switch (type) {
    case 'start':
      return (
        timeMoment.isSameOrAfter(moment('00:00:00', 'HH:mm:ss')) &&
        timeMoment.isSameOrBefore(moment('23:58:00', 'HH:mm:ss')) &&
        timeMoment.isBefore(oppositeTimeMoment)
      );
    case 'end':
      return (
        timeMoment.isSameOrAfter(moment('00:01:00', 'HH:mm:ss')) &&
        timeMoment.isSameOrBefore(moment('23:59:59', 'HH:mm:ss')) &&
        timeMoment.isAfter(oppositeTimeMoment)
      );
    default:
      return true;
  }
};

export default PromobannerValidity;
